import useSWR from "swr";

import { type DocumentDetails } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/documents";

export function useDocument(id: string | number | undefined) {
  return useSWR<DocumentDetails, Error>(
    id ? `${url}/${id}` : null,
    simpleFetcher,
  );
}
